import { AbstractModel } from '../base';
import { ITax, ITaxData } from './tax.types';

export class Tax extends AbstractModel implements ITax {
  readonly id?: number;
  readonly name: string;
  readonly rate: number;

  constructor(data: ITaxData) {
    super();

    const requiredFields: (keyof ITaxData)[] = ['name', 'rate'];

    this.validate(data, requiredFields);

    if (data.id) {
      this.id = data.id;
    }

    this.name = data.name!;
    this.rate = data.rate!;
  }

  toString(): string {
    return `${this.name} - ${this.rate}%`;
  }
}
